import React from "react";
import { useNavigate } from "react-router-dom";
const BackIcon = () => {
    const navigate = useNavigate()
    return(
        <div className="back-icon-btn mt-3">
            <button onClick={(e) => {
                navigate(-1)
            }}>عودة</button>
        </div>
    )
}
export default BackIcon